import { useMissionDetailingStore } from '../../store/useMissionDetailingStore';
import { useMissionStore } from '../../../shared/store/useMissionStore';

export const MissionSummaryChapter = () => {
  const missionPage = useMissionDetailingStore((state) => state.missionPage);
  const mission = useMissionStore((state) => state.mission);

  if (!missionPage || !mission) {
    return null;
  }

  return (
    <div>
      <h2 className="mb-1 font-cadiz text-sh-16-20 font-bold">{missionPage.chaptersTitle}</h2>
      <div>
        {mission?.chapters?.map((chapter, index) => (
          <p key={chapter?.uuid} className="!my-0 flex flex-row items-center font-cadiz text-sh-16-24">
            <span className="mr-2">{index + 1}.</span>
            <a href={`#${chapter?.uuid}`} className="text-primary-600 visited:text-primary-600 hover:!text-primary-950">
              {chapter?.title}
            </a>
          </p>
        ))}
      </div>
    </div>
  );
};
